import { createSelector } from 'reselect'
import getCheckoutLoyaltyEarnKeyMarkers from './getCheckoutLoyaltyEarnKeyMarkers'
import composeEarnKey from 'loyalty/lib/pointsCalculation/earnKey/composeEarnKey'
import getCheckoutAccommodationPointsCalculationRequests from './getCheckoutAccommodationPointsCalculationRequests'
import getCheckoutLuxPlusPointsCalculationRequests from './getCheckoutLuxPlusPointsCalculationRequests'
import getCheckoutInsurancePointsCalculationRequests from './getCheckoutInsurancePointsCalculationRequests'
import { EmptyArray } from 'lib/array/arrayUtils'
import getCheckoutVillasPointsCalculationRequests from './getCheckoutVillasPointsCalculationRequests'
import getCheckoutTourExperiencePointsCalculationRequests
  from 'checkout/selectors/loyalty/pointsCalculation/getCheckoutTourExperiencePointsCalculationRequests'
import getCheckoutFlightsPointsCalculationRequests from './getCheckoutFlightsPointsCalculationRequest'
import getCheckoutExperiencePointsCalculationRequests from './getCheckoutExperiencePointsCalculationRequests'
import getCheckoutCarHirePointsCalculationRequests from './getCheckoutCarHirePointsCalculationRequests'
import getCheckoutLoungePassPointsCalculationRequest from './getCheckoutLoungePassPointsCalculationRequest'
import getCheckoutTransfersPointsCalculationRequest from './getCheckoutTransfersPointsCalculationRequest'
import getCheckoutMerchandisePointsCalculationRequests from './getCheckoutMerchandisePointsCalculationRequests'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import getCheckoutMerchandiseShippingPointsCalculationRequests from './getCheckoutMerchandiseShippingPointsCalculationRequests'
import getCheckoutLoyaltyEarnPaymentMethods from './getCheckoutLoyaltyEarnPaymentMethods'
import getCheckoutLoyaltyEarnOrderContext from './getCheckoutLoyaltyEarnOrderContext'

const getCheckoutPointsCalculationRequests = createSelector(
  (state: App.State) => getIsCurrentRegionUserLoyaltyRegion(state),
  (state: App.State) => state.checkout.cart.currencyCode,
  getCheckoutLoyaltyEarnKeyMarkers,
  (state: App.State) => getCheckoutLoyaltyEarnPaymentMethods(state),
  (state: App.State) => getCheckoutLoyaltyEarnOrderContext(state),
  (state: App.State) => getCheckoutAccommodationPointsCalculationRequests(state),
  (state: App.State) => getCheckoutTourExperiencePointsCalculationRequests(state),
  (state: App.State) => getCheckoutVillasPointsCalculationRequests(state),
  (state: App.State) => getCheckoutLuxPlusPointsCalculationRequests(state),
  (state: App.State) => getCheckoutInsurancePointsCalculationRequests(state),
  (state: App.State) => getCheckoutFlightsPointsCalculationRequests(state),
  (state: App.State) => getCheckoutExperiencePointsCalculationRequests(state),
  (state: App.State) => getCheckoutCarHirePointsCalculationRequests(state),
  (state: App.State) => getCheckoutLoungePassPointsCalculationRequest(state),
  (state: App.State) => getCheckoutTransfersPointsCalculationRequest(state),
  (state: App.State) => getCheckoutMerchandisePointsCalculationRequests(state),
  (state: App.State) => getCheckoutMerchandiseShippingPointsCalculationRequests(state),
  // Add other verticals here
  (
    isCurrentRegionUserLoyaltyRegion,
    cartCurrencyCode,
    earnKeyMarkers,
    paymentMethods,
    orderContext,
    ...allCalculationRequests
  ): Array<App.LoyaltyPointsEarnCalculationRequest> => {
    if (!isCurrentRegionUserLoyaltyRegion) return EmptyArray

    // Fixes occasional mismatch between cart currency and geo currency
    return allCalculationRequests.flat().map((request) => ({
      ...request,
      currency: cartCurrencyCode,
      earnKey: composeEarnKey(request.earnKey, earnKeyMarkers),
      paymentMethods,
      orderId: request.orderId ?? orderContext?.orderId,
      bookingDate: orderContext?.bookingDate,
    }))
  },
)

export default getCheckoutPointsCalculationRequests
